document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".animated-text");

  const animateValue = (el, start, end, duration) => {
    let startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      el.textContent = Math.floor(progress * (end - start) + start).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        let html = el.innerHTML;

        el.innerHTML = html.replace(/(\d[\d.,]*)/g, '<span class="countup" data-target="$1">0</span>');

        el.querySelectorAll(".countup").forEach(span => {
          let target = parseInt(span.dataset.target.replace(/[.,]/g, ""));
          animateValue(span, 0, target, 1300);
        });

        observer.unobserve(el);
      }
    });
  }, { threshold: 0.3 });

  elements.forEach(el => observer.observe(el));
});


